<div class="container-fluid">
  <div class="row">
    <div class="col-6">
      <div style="margin-left:0px;">
        <span><strong>Credential Types</strong></span><br />
      </div>

      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-4">
              <mat-form-field style="margin-top:5px;width:100%;margin-left:0px;">
                <mat-label>Add Credential Type Id</mat-label>
                <input matInput type="number" min="1" step="1" placeholder="e.g. 7" value="Credential Type Id" [(ngModel)]="credentialTypeIdInputValue" (keypress)="onMonitorCredentialTypesChange()">
              </mat-form-field>
            </div>
            <div class="col-7">
              <mat-form-field style="margin-top:5px;width:100%;margin-left:0px;">
                <mat-label>Add Credential Type</mat-label>
                <input matInput placeholder="e.g. AVI/Prox/Magstripe" value="Credential Type" [(ngModel)]="credentialTypeInputValue" (keypress)="onMonitorCredentialTypesChange()">
              </mat-form-field>
            </div>
            <div class="col-1">
              <button class="mt-2" mat-icon-button color="primary" aria-label="Add Credential Type" matTooltip="Add Credential Type" (click)="onAddCredentialType()" [disabled]="disableAddNewCredentialType">
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </div>
          <div class="row">
             <div class="col-11">
                <mat-checkbox class="example-margin" [(ngModel)]="noSystemCodeChecked" (change)="onNoSystemCodeChange($event)">No Credential System Codes for this Credential Type</mat-checkbox>
             </div>
            <div class="col-11">
                 @if(credentialTypesList.length === 0){
                  <span style="font-size:14px;color:black;">There are no Credential Types available.  Please add a Credential Type first.</span>
                }
                @else{
              <mat-selection-list [(ngModel)]="credentialTypeSettingListValue"  [multiple]="false" [hideSingleSelectionIndicator]="true" style="max-height: 300px; overflow-y: auto; border: 1px solid #ccc; border-radius: 4px;">
                @for (type of credentialTypesList; track type.credentialTypeId) {
                  <mat-list-option [value]="type.credentialTypeId" (click)="onCredentialTypeChange(type.credentialTypeId)">
                    {{type.credentialTypeName}} (Id: {{type.credentialTypeId}})
                  </mat-list-option>
                }
              </mat-selection-list>
            }
            </div>
            <div class="col-1">
              <button class="mt-2" mat-icon-button color="primary" aria-label="Remove Credential Type" matTooltip="Remove Credential Type" (click)="onRemoveCredentialType()" [disabled]="disableRemoveCredentialType">
                <mat-icon>remove</mat-icon>
              </button>
            </div>
          </div>
      </div>
    </div>


     </div>
    <div class="col-6">
      <div style="margin-left:0px;">
        <span><strong>Credential Codes</strong></span><br />
      </div>
      @if(noSystemCodeChecked){
        <div style="margin-top:20px;">
          <span style="font-size:14px;color:black;">System Codes cannot be added when "No Credential System Codes for this Credential Type" is selected on Credential Types.</span>
        </div>
      }
      @else{
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-11">
              <mat-form-field style="margin-top:5px;width:100%;margin-left:0px;">
                <mat-label>Add Credential Code</mat-label>
                <input matInput placeholder="e.g. 7" value="Credential Code" [(ngModel)]="credentialCodeInputValue" (keyup)="onMonitorCredentialIdChange()">
              </mat-form-field>
            </div>
            <div class="col-1">
              <button class="mt-2" mat-icon-button color="primary" aria-label="Add Credential Code" matTooltip="Add Credential Code" (click)="onAddCredentialCode()" [disabled]="disableAddNewCredentialCode" >
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-11">
                @if(credentialCodesList.length === 0){
                  <span style="font-size:14px;color:black;">There are no Credential Codes available.  Select a Credential Type first.</span>
                }
                @else{
                <mat-selection-list [(ngModel)]="credentialCodeSettingListValue"  [multiple]="false" [hideSingleSelectionIndicator]="true" style="max-height: 300px; overflow-y: auto; border: 1px solid #ccc; border-radius: 4px;">
                    @for (type of credentialCodesList; track type.credentialCode) {
                    <mat-list-option [value]="type.credentialCode" (click)="onCredentialCodeChange(type.credentialCode)">
                        {{type.credentialCode}}
                    </mat-list-option>
                    }
                </mat-selection-list>
            }
            </div>
            <div class="col-1">
              <button class="mt-2" mat-icon-button color="primary" aria-label="Remove Credential Code" matTooltip="Remove Credential Code" (click)="onRemoveCredentialCode()" [disabled]="disableRemoveCredentialCode">
                <mat-icon>remove</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>
